import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";
// @ts-ignore
export const SubGridContainer = styled("div")(() => ({
  margin: "-6px -17px -6px -17px",
  padding: "8px !important",
  position: "relative",
  backgroundColor: colors.gray100,
  "& > div > div > div > table > tbody > tr": {
    backgroundColor: "#fff !important",
  },
  "& .tableContainerX": {
    position: "relative",
    backgroundColor: "#fff !important",
    "&:before": {
      content: "''",
      position: "absolute",
      left: 0,
      right: 0,
      width: "100%",
      height: "1000px",
      zIndex: 2,
      pointerEvents: "none",
    },
  },
  "& table": {
    background: colors.white,
    borderCollapse: "separate !important",
    borderRadius: "8px !important",
    borderWidth: "1px",
    borderColor: colors.gray300,
    borderStyle: "solid",
  },
  "& table thead": {
    backgroundColor: "rgba(237, 245, 251, 1) !important",
  },
  "& table thead th:last-child": {
    borderTopRigthRadius: "8px !important",
    border: "unset !important",
    paddingRight: "5px",
  },
  "& table thead th:first-child": {
    borderTopLeftRadius: "8px !important",
    border: "unset !important",
  },
  "& table thead tr": {
    backgroundColor: "rgba(237, 245, 251, 1) !important",
  },
  "& table thead tr th:first-child": {
    paddingLeft: "15px !important",
  },
  "& table .tr-header th:first-child,th:last-child": {
    textAlign: "start !important",
    paddingLeft: "5px",
  },
  "& table tbody tr td:first-child": {
    paddingLeft: "15px !important",
  },
  "& table tbody tr td:last-child": {
    width: "5%",
  },
  "& .MuiTableContainer-root": {
    overflowX: "hidden !important",
  },
  "& .MuiTableBody-root tr.MuiTableRow-root:nth-child(even)": {
    backgroundColor: `${colors.gray50} !important`,
  },
}));
